import { type E2ESelectors } from '@grafana/e2e-selectors';

export const QueryLibraryComponents = {
  saveQueryButton: {
    button: 'data-testid save to query library button',
  },
  replaceQueryButton: {
    button: 'data-testid replace query from library button',
  },
  savedQueriesMenuButton: {
    button: 'data-testid saved queries button',
  },
  saveQueryModal: {
    modal: 'data-testid save to query library modal',
    cancel: 'data-testid save to query library modal cancel',
    confirm: 'data-testid save to query library modal confirm',
    title: 'data-testid save to query library modal title',
    description: 'data-testid save to query library modal description',
    tagsInput: 'data-testid save to query library modal tags input',
  },
  savedQueriesModal: {
    content: 'data-testid saved queries modal content',
    item: (title: string) => `data-testid saved queries modal item ${title}`,
    titleInput: 'data-testid saved queries modal title input',
    descriptionInput: 'data-testid saved queries modal description input',
    saveButton: 'data-testid saved queries modal save button',
    editButton: 'data-testid saved queries modal edit button',
    selectButton: 'data-testid saved queries modal select button',
    editInExploreButton: 'data-testid saved queries modal edit in explore button',
    duplicateButton: 'data-testid saved queries modal duplicate button',
    deleteButton: 'data-testid saved queries modal delete button',
    searchInput: 'data-testid saved queries modal search input',
    datasourceInput: 'data-testid saved queries modal datasource input',
    authorInput: 'data-testid saved queries modal author input',
  },
};

export const QueryLibraryPages = {};

export const selectors: {
  pages: E2ESelectors<typeof QueryLibraryPages>;
  components: E2ESelectors<typeof QueryLibraryComponents>;
} = {
  pages: QueryLibraryPages,
  components: QueryLibraryComponents,
};
